module.exports = __webpack_public_path__ + "img/51972192598_ac11da01ca_w.e40197e5.jpg";